import { YOO_FINDS_CDN } from "@/common";

const BF_CDN_BASE_PATH = `${YOO_FINDS_CDN}/hitfinds/activity/bf`;

export const BF_HERO_BG = `${BF_CDN_BASE_PATH}/2026-bf-banner.png?imageMogr2/format/webp`;
